import styled, { css } from 'styled-components'

export const AppointmentsContainer = styled.div`
	width: 100%;
	box-sizing: border-box;
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 16px;

	@media (max-width: ${p => p.theme.sizes.breakPoints.small}) {
		${({ isCarousel }) =>
		isCarousel
			? css`
						display: flex;
						flex-wrap: nowrap;
						overflow-x: auto;
						width: clamp(350px, 90vw, 600px);
						-webkit-overflow-scrolling: touch;
						scroll-snap-type: x mandatory;
						overscroll-behavior-x: contain;
						gap: 16px;
						touch-action: pan-x;
						&::-webkit-scrollbar {
							display: none;
						}
						-ms-overflow-style: none;
						scrollbar-width: none;
				  `
			: css`
						display: flex;
						flex-direction: column;
						flex-wrap: nowrap;
						overflow-x: unset;
						width: 100%;
				  `}
	}
`
export const ButtonContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: ${({ justifyContent }) => (justifyContent ? justifyContent : 'space-between')};
	gap: 16px;
	border-left: 1px solid ${props => props.theme.colors.greys.dividerGray};
	border-right: 1px solid ${props => props.theme.colors.greys.dividerGray};
	border-bottom: 1px solid ${props => props.theme.colors.greys.dividerGray};
	border-radius: 8px;
	border-top-left-radius: 0;
	border-top-right-radius: 0;
	padding: 2px 16px;
`

export const VerticalDivider = styled.div`
	width: 1px;
	background: ${props => props.theme.colors.greys.dividerGray};
	align-self: center;
	height: 20px;
`

export const AppointmentCarConteiner = styled.div`
	display: flex;
	flex-direction: column;
`

export const AppointmentsWrapper = styled.div`
	width: 100%;
	position: relative;
	touch-action: pan-x;
`

export const AppointmentCard = styled.div`
	background:  ${props => props.$isHistory ? props.theme.colors.greys.cardHistoryBg : props.theme.colors.brand.backgroundBlue};
	border-radius: 12px;
	border-bottom-left-radius: ${({ $hasBottomBR }) => ($hasBottomBR ? '12px' : '0')};
	border-bottom-right-radius: ${({ $hasBottomBR }) => ($hasBottomBR ? '12px' : '0')};
	padding: 16px;
	display: flex;
	gap: 16px;
	min-height: 112px;
	cursor: pointer;
	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		flex: 0 0 auto;
		scroll-snap-align: start;
	}
`

export const DateBadge = styled.div`
	background-color: ${props =>
		props.$isHistory ? props.theme.colors.greys.disabledGrey : props.theme.colors.brand.blueOmint};
	color: white;
	border-radius: 8px;
	padding: 12px 16px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	min-width: 80px;
	flex-shrink: 0;
`

export const InfoRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
`

export const StatusBadge = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
	flex-shrink: 0;
	font-size: 13px;
	font-weight: 600;
	color: ${props => props.$color || props.theme.colors.feedback.error};
`

export const StatusIconCircle = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 14px;
	height: 14px;
	border-radius: 50%;
	border: 1px solid ${props => props.$color || props.theme.colors.feedback.error};
`

export const DetailFooter = styled.div`
	border-top: 1px solid ${props => props.theme.colors.greys.dividerGray};
	padding-top: 12px;
`

export const DateDay = styled.div`
	font-size: 18px;
	font-weight: 700;
`

export const DateTime = styled.div`
	font-size: 14px;
	font-weight: 500;
`

export const AppointmentInfo = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	flex: 1;
	min-width: 0;
	overflow: hidden;
	justify-content: space-between;
`

export const ClinicName = styled.div`
	font-size: 16px;
	font-weight: 600;
	color: ${props => props.theme.colors.text.primaryText};
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`

export const Professional = styled.div`
	font-size: 14px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`

export const AppointmentType = styled.div`
	font-size: 14px;
	color: ${props => props.theme.colors.greys.disabledGrey};
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`
